import { defineStore } from 'pinia';
import UserService from '@/service/UserService';

export const UserStore = defineStore('userStore', {
  state: () => ({
    users: [],
    usersAssign: []
  }),
  getters: {
    selectUser: (state) => state.users,
    selectUserAssign: (state) => state.usersAssign
  },
  actions: {
    async handleGetUserSecure(username, password) {
      const userService = new UserService();
      try {
        const res = await userService.getUserSecure(username, password);
        this.updateUser(res.data);
        return res;
      } catch (e) {
        return false;
      }
    },
    async handleGetUser() {
      const userService = new UserService();
      try {
        const res = await userService.getUsers();
        this.updateUser(res.data);
        return res;
      } catch (e) {
        return false;
      }
    },
    async handleGetUserAssign() {
      const userService = new UserService();
      try {
        const res = await userService.getUsersAssign();
        this.updateUserAssign(res.data);
        return res;
      } catch (e) {
        return false;
      }
    },
    updateUser(payload) {
      this.users = payload;
      if (this.users?.length) {
        this.users.sort((a, b) => {
          return a?.displayName.localeCompare(b?.displayName);
        });
        this.users.reverse();
      }
    },
    updateUserAssign(payload: any) {
      this.usersAssign = payload;
      if (this.usersAssign?.length) {
        this.usersAssign.sort((a, b) => {
          return a?.displayName.localeCompare(b?.displayName);
        });
        this.usersAssign.reverse();
      }
    },
    clearTokens() {
      if (this.users?.length) {
        this.users.forEach((group) =>
          group.members.forEach((member) => {
            member.token = undefined;
          })
        );
      }
    }
  }
});
